import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getBaseQueryWithReauth from '../../../utils/api/query-auth';
import getAuth from '../../../utils/api/getToken';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Timesheet`,
  prepareHeaders: (headers) => {
    const token = getAuth();
    if (token) {
      headers.set('authorization', `Bearer ${token.auth}`);
    }
    return headers;
  },
});

export const workTypesApi: any = createApi({
  reducerPath: 'worktypes',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  keepUnusedDataFor: 60 * 60 * 8, // 8 hours in seconds
  endpoints: (builder) => ({
    getWorkTypes: builder.query({
      query: () => `/getWorkTypes`,
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetWorkTypesQuery } = workTypesApi;
